const config = {
  defaultLanguage: "english",
  options: [
    {
      languageId: "english",
      locale: "en-US",
      text: "English",
    },
    {
      languageId: "spanish",
      locale: "es-ES",
      text: "Español",
    },
    {
      languageId: "portuguese",
      locale: "pt-BR",
      text: "Português",
    },
  ],
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach((language) => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
